import _classCallCheck from "/pubskape-frontend/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/pubskape-frontend/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/pubskape-frontend/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/pubskape-frontend/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/pubskape-frontend/node_modules/@babel/runtime/helpers/esm/inherits";
import { __rest } from "tslib";
import * as React from 'react';
import styles from '@patternfly/react-styles/css/components/Tabs/tabs';
import buttonStyles from '@patternfly/react-styles/css/components/Button/button';
import { css } from '@patternfly/react-styles';
import AngleLeftIcon from '@patternfly/react-icons/dist/esm/icons/angle-left-icon';
import AngleRightIcon from '@patternfly/react-icons/dist/esm/icons/angle-right-icon';
import { getUniqueId, isElementInView, formatBreakpointMods } from '../../helpers/util';
import { TabContent } from './TabContent';
import { TabsContextProvider } from './TabsContext';
import { Button } from '../Button';
import { getOUIAProps, getDefaultOUIAId, canUseDOM } from '../../helpers';
import { GenerateId } from '../../helpers/GenerateId/GenerateId';
export var TabsComponent;

(function (TabsComponent) {
  TabsComponent["div"] = "div";
  TabsComponent["nav"] = "nav";
})(TabsComponent || (TabsComponent = {}));

var variantStyle = {
  default: '',
  light300: styles.modifiers.colorSchemeLight_300
};
export var Tabs =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Tabs, _React$Component);

  function Tabs(props) {
    var _this;

    _classCallCheck(this, Tabs);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Tabs).call(this, props));
    _this.tabList = React.createRef();

    _this.handleScrollButtons = function () {
      var container = _this.tabList.current;
      var disableLeftScrollButton = true;
      var disableRightScrollButton = true;
      var showScrollButtons = false;

      if (container && !_this.props.isVertical) {
        // get first element and check if it is in view
        var overflowOnLeft = !isElementInView(container, container.firstChild, false); // get last element and check if it is in view

        var overflowOnRight = !isElementInView(container, container.lastChild, false);
        showScrollButtons = overflowOnLeft || overflowOnRight;
        disableLeftScrollButton = !overflowOnLeft;
        disableRightScrollButton = !overflowOnRight;
      }

      _this.setState({
        showScrollButtons: showScrollButtons,
        disableLeftScrollButton: disableLeftScrollButton,
        disableRightScrollButton: disableRightScrollButton
      });
    };

    _this.scrollLeft = function () {
      // find first Element that is fully in view on the left, then scroll to the element before it
      if (_this.tabList.current) {
        var container = _this.tabList.current;
        var childrenArr = Array.from(container.children);
        var firstElementInView;
        var lastElementOutOfView;
        var i;

        for (i = 0; i < childrenArr.length && !firstElementInView; i++) {
          if (isElementInView(container, childrenArr[i], false)) {
            firstElementInView = childrenArr[i];
            lastElementOutOfView = childrenArr[i - 1];
          }
        }

        if (lastElementOutOfView) {
          container.scrollLeft -= lastElementOutOfView.scrollWidth;
        }
      }
    };

    _this.scrollRight = function () {
      // find last Element that is fully in view on the right, then scroll to the element after it
      if (_this.tabList.current) {
        var container = _this.tabList.current;
        var childrenArr = Array.from(container.children);
        var lastElementInView;
        var firstElementOutOfView;

        for (var i = childrenArr.length - 1; i >= 0 && !lastElementInView; i--) {
          if (isElementInView(container, childrenArr[i], false)) {
            lastElementInView = childrenArr[i];
            firstElementOutOfView = childrenArr[i + 1];
          }
        }

        if (firstElementOutOfView) {
          container.scrollLeft += firstElementOutOfView.scrollWidth;
        }
      }
    };

    _this.state = {
      showScrollButtons: false,
      disableLeftScrollButton: true,
      disableRightScrollButton: true,
      shownKeys: _this.props.defaultActiveKey !== undefined ? [_this.props.defaultActiveKey] : [_this.props.activeKey],
      uncontrolledActiveKey: _this.props.defaultActiveKey,
      uncontrolledIsExpandedLocal: _this.props.defaultIsExpanded,
      ouiaStateId: getDefaultOUIAId(Tabs.displayName)
    };

    if (_this.props.isVertical && _this.props.expandable !== undefined) {
      if (!_this.props.toggleAriaLabel && !_this.props.toggleText) {
        // eslint-disable-next-line no-console
        console.error('Tabs:', 'toggleAriaLabel or the toggleText prop is required to make the toggle button accessible');
      }
    }

    return _this;
  }

  _createClass(Tabs, [{
    key: "handleTabClick",
    value: function handleTabClick(event, eventKey, tabContentRef) {
      // When tab is an achor tag with href, cancel navigation event
      event.preventDefault();
      var shownKeys = this.state.shownKeys;
      var _this$props = this.props,
          onSelect = _this$props.onSelect,
          defaultActiveKey = _this$props.defaultActiveKey; // if defaultActiveKey Tabs are uncontrolled, set new active key internally

      if (defaultActiveKey !== undefined) {
        this.setState({
          uncontrolledActiveKey: eventKey
        });
      } else {
        onSelect(event, eventKey);
      } // process any tab content sections outside of the component


      if (tabContentRef) {
        React.Children.toArray(this.props.children).map(function (child) {
          return child;
        }).filter(function (child) {
          return child.props && child.props.tabContentRef && child.props.tabContentRef.current;
        }).forEach(function (child) {
          return child.props.tabContentRef.current.hidden = true;
        }); // most recently selected tabContent

        if (tabContentRef.current) {
          tabContentRef.current.hidden = false;
        }
      }

      if (this.props.mountOnEnter) {
        this.setState({
          shownKeys: shownKeys.concat(eventKey)
        });
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!this.props.isVertical) {
        if (canUseDOM) {
          window.addEventListener('resize', this.handleScrollButtons, false);
        } // call the handle resize function to check if scroll buttons should be shown


        this.handleScrollButtons();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (!this.props.isVertical) {
        if (canUseDOM) {
          window.removeEventListener('resize', this.handleScrollButtons, false);
        }
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props2 = this.props,
          activeKey = _this$props2.activeKey,
          mountOnEnter = _this$props2.mountOnEnter;
      var shownKeys = this.state.shownKeys;

      if (prevProps.activeKey !== activeKey && mountOnEnter && shownKeys.indexOf(activeKey) < 0) {
        this.setState({
          shownKeys: shownKeys.concat(activeKey)
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _a = this.props,
          className = _a.className,
          children = _a.children,
          activeKey = _a.activeKey,
          defaultActiveKey = _a.defaultActiveKey,
          id = _a.id,
          isFilled = _a.isFilled,
          isSecondary = _a.isSecondary,
          isVertical = _a.isVertical,
          isBox = _a.isBox,
          leftScrollAriaLabel = _a.leftScrollAriaLabel,
          rightScrollAriaLabel = _a.rightScrollAriaLabel,
          ariaLabel = _a['aria-label'],
          component = _a.component,
          ouiaId = _a.ouiaId,
          ouiaSafe = _a.ouiaSafe,
          mountOnEnter = _a.mountOnEnter,
          unmountOnExit = _a.unmountOnExit,
          usePageInsets = _a.usePageInsets,
          inset = _a.inset,
          variant = _a.variant,
          expandable = _a.expandable,
          isExpanded = _a.isExpanded,
          defaultIsExpanded = _a.defaultIsExpanded,
          toggleText = _a.toggleText,
          toggleAriaLabel = _a.toggleAriaLabel,
          onToggle = _a.onToggle,
          props = __rest(_a, ["className", "children", "activeKey", "defaultActiveKey", "id", "isFilled", "isSecondary", "isVertical", "isBox", "leftScrollAriaLabel", "rightScrollAriaLabel", 'aria-label', "component", "ouiaId", "ouiaSafe", "mountOnEnter", "unmountOnExit", "usePageInsets", "inset", "variant", "expandable", "isExpanded", "defaultIsExpanded", "toggleText", "toggleAriaLabel", "onToggle"]);

      var _this$state = this.state,
          showScrollButtons = _this$state.showScrollButtons,
          disableLeftScrollButton = _this$state.disableLeftScrollButton,
          disableRightScrollButton = _this$state.disableRightScrollButton,
          shownKeys = _this$state.shownKeys,
          uncontrolledActiveKey = _this$state.uncontrolledActiveKey,
          uncontrolledIsExpandedLocal = _this$state.uncontrolledIsExpandedLocal;
      var filteredChildren = React.Children.toArray(children).filter(Boolean).filter(function (child) {
        return !child.props.isHidden;
      });
      var uniqueId = id || getUniqueId();
      var Component = component === TabsComponent.nav ? 'nav' : 'div';
      var localActiveKey = defaultActiveKey !== undefined ? uncontrolledActiveKey : activeKey;
      var isExpandedLocal = defaultIsExpanded !== undefined ? uncontrolledIsExpandedLocal : isExpanded;
      /*  Uncontrolled expandable tabs */

      var toggleTabs = function toggleTabs(newValue) {
        if (isExpanded === undefined) {
          _this2.setState({
            uncontrolledIsExpandedLocal: newValue
          });
        } else {
          onToggle(newValue);
        }
      };

      return React.createElement(TabsContextProvider, {
        value: {
          variant: variant,
          mountOnEnter: mountOnEnter,
          unmountOnExit: unmountOnExit,
          localActiveKey: localActiveKey,
          uniqueId: uniqueId,
          handleTabClick: function handleTabClick() {
            return _this2.handleTabClick.apply(_this2, arguments);
          }
        }
      }, React.createElement(Component, Object.assign({
        "aria-label": ariaLabel,
        className: css(styles.tabs, isFilled && styles.modifiers.fill, isSecondary && styles.modifiers.secondary, isVertical && styles.modifiers.vertical, isVertical && expandable && formatBreakpointMods(expandable, styles), isVertical && expandable && isExpandedLocal && styles.modifiers.expanded, isBox && styles.modifiers.box, showScrollButtons && !isVertical && styles.modifiers.scrollable, usePageInsets && styles.modifiers.pageInsets, formatBreakpointMods(inset, styles), variantStyle[variant], className)
      }, getOUIAProps(Tabs.displayName, ouiaId !== undefined ? ouiaId : this.state.ouiaStateId, ouiaSafe), {
        id: id && id
      }, props), expandable && isVertical && React.createElement(GenerateId, null, function (randomId) {
        return React.createElement("div", {
          className: css(styles.tabsToggle)
        }, React.createElement("div", {
          className: css(styles.tabsToggleButton)
        }, React.createElement(Button, {
          onClick: function onClick() {
            return toggleTabs(!isExpandedLocal);
          },
          variant: "plain",
          "aria-label": toggleAriaLabel,
          "aria-expanded": isExpandedLocal,
          id: "".concat(randomId, "-button"),
          "aria-labelledby": "".concat(randomId, "-text ").concat(randomId, "-button")
        }, React.createElement("span", {
          className: css(styles.tabsToggleIcon)
        }, React.createElement(AngleRightIcon, {
          "arian-hidden": "true"
        })), toggleText && React.createElement("span", {
          className: css('pf-c-tabs__toggle-text'),
          id: "".concat(randomId, "-text")
        }, toggleText))));
      }), React.createElement("button", {
        className: css(styles.tabsScrollButton, isSecondary && buttonStyles.modifiers.secondary),
        "aria-label": leftScrollAriaLabel,
        onClick: this.scrollLeft,
        disabled: disableLeftScrollButton,
        "aria-hidden": disableLeftScrollButton
      }, React.createElement(AngleLeftIcon, null)), React.createElement("ul", {
        className: css(styles.tabsList),
        ref: this.tabList,
        onScroll: this.handleScrollButtons
      }, filteredChildren), React.createElement("button", {
        className: css(styles.tabsScrollButton, isSecondary && buttonStyles.modifiers.secondary),
        "aria-label": rightScrollAriaLabel,
        onClick: this.scrollRight,
        disabled: disableRightScrollButton,
        "aria-hidden": disableRightScrollButton
      }, React.createElement(AngleRightIcon, null))), filteredChildren.filter(function (child) {
        return child.props.children && !(unmountOnExit && child.props.eventKey !== localActiveKey) && !(mountOnEnter && shownKeys.indexOf(child.props.eventKey) === -1);
      }).map(function (child, index) {
        return React.createElement(TabContent, {
          key: index,
          activeKey: localActiveKey,
          child: child,
          id: child.props.id || uniqueId,
          ouiaId: child.props.ouiaId
        });
      }));
    }
  }]);

  return Tabs;
}(React.Component);
Tabs.displayName = 'Tabs';
Tabs.defaultProps = {
  activeKey: 0,
  onSelect: function onSelect() {
    return undefined;
  },
  isFilled: false,
  isSecondary: false,
  isVertical: false,
  isBox: false,
  leftScrollAriaLabel: 'Scroll left',
  rightScrollAriaLabel: 'Scroll right',
  component: TabsComponent.div,
  mountOnEnter: false,
  unmountOnExit: false,
  ouiaSafe: true,
  variant: 'default',
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  onToggle: function onToggle(isExpanded) {
    return undefined;
  }
};